import { setVersion } from './setVersion';
export { setVersion };
setVersion('@fluentui/set-version', '6.0.0');